
export default {
    preload: {
        resources: [
            'doctor.png', 'icon_fb.png', 'icon_google.png'
        ],
        web: [
            'bg.jpg', 'icon_apple.png', 'button_log_bg.png', 'list_bg.jpg'
        ],
        mobile: [
            'icon_apple_w.png', 'login_bg.jpg', 'button_bg.png', 'list_bg_m.jpg', 'id_bg.png'
        ]
    },
    lazy: {
        resources: [
            'dinero_en.png', 'dinero_es.png', 'dinero_pt.png', 'icon_loyalty.png',
            'logout_icon.png', 'logout_icon_bg.png', 'pix_btn.png', 'pix_icon.png', 'ok_btn.png', 'pay_popup.png',
            'pay_popup_close.png', 'pic_title.png', 'popup_bg.png', 'price_icon_bg.png',
            'top_balance_bg.png', 'avatar.png', 'balance_bg.png', 'balance_coins_icon.png',
            'bank_coins_bg.png', 'bank_dinero_bg.png', 'btn_buy.png',
            'balance_dinero_icon.png', 'bundles_wheel_pic.png', 'black_wheel_pic.png',
            'coins_1.png', 'coins_2.png', 'coins_3.png', 'coins_4.png', 'coins_5.png', 'coins_6.png',
            'chips_1.png', 'chips_2.png', 'chips_3.png', 'chips_4.png', 'chips_5.png', 'chips_6.png',
            'promotion_en.png', 'promotion_es.png', 'promotion_pt.png',
            'button_cancel.png', 'button_yes.png', 'coins_en.png', 'coins_es.png',
            'coins_pt.png', 'collect_button.png', 'collect_popup_bg.png', 'coins_animation.png', 'dinero_animation.png',
            'close_btn.png', 'step1.png', 'step2.png', 'tutorial_button.png', 'tutorial_close.png', 'tutorial_title_en.png',
            'tutorial_title_es.png', 'tutorial_title_pt.png', 'user_id_tutorial_bg.png'
        ],
        web: [],
        mobile: []
    }
}



// WEBPACK FOOTER //
// ./src/assets/AssetsConfig.js